import datetimeFmt from '@planningcenter/datetime-fmt';
import moment from '../../_virtual/moment.js';
import { BUTTON_STYLE_BASE_OVERRIDES } from '../constants.js';
import colors from '../vendor/topbar/colors.js';

const noop = () => { };
// until we can use Array.prototype.findLast
const findLast = (xs, p) => {
    for (let i = xs.length - 1; i >= 0; i--) {
        if (p(xs[i], i, xs))
            return xs[i];
    }
    return undefined;
};
const getPrimaryButtonStyleOverrides = ({ disabled, spinner, } = {}) => {
    const base = {
        ...BUTTON_STYLE_BASE_OVERRIDES,
        backgroundColor: colors.interaction55,
        color: spinner ? "transparent" : "surface",
        spinner: spinner ? { color: colors.interaction55 } : undefined,
    };
    if (disabled)
        return {
            ...base,
            backgroundColor: colors.lightNeutral81,
            spinner: spinner ? { color: colors.lightNeutral81 } : undefined,
        };
    return {
        ...base,
        active: { backgroundColor: colors.interaction45 },
        focus: { backgroundColor: colors.interaction55 },
        hover: { backgroundColor: colors.interaction50 },
    };
};
const formatDate = (date, userLanguage) => {
    const now = moment();
    const isToday = now.isSame(date, "day");
    const isThisWeek = now.isSame(date, "week");
    const isThisYear = now.isSame(date, "year");
    // TODO: Unify date and time formats
    // This is a temporary workaround to match the timestamps Stream uses within the MessageList
    // The pattern is pulled from Stream's Docs: https://getstream.io/chat/docs/sdk/react/v11/guides/customization/channel_list_preview/#custom-channel-preview
    const streamStyleFormatter = new Intl.DateTimeFormat(userLanguage, {
        timeStyle: "short",
    });
    if (isToday)
        return streamStyleFormatter.format(date);
    if (isThisWeek)
        return datetimeFmt.date(date, { style: "relative" });
    if (isThisYear)
        return datetimeFmt.date(date, { style: "abbreviated" });
    return datetimeFmt.date(date, { style: "short", year: true });
};

export { findLast, formatDate, getPrimaryButtonStyleOverrides, noop };
//# sourceMappingURL=index.js.map
